angular.module('cvsApp').factory('placeOrderHelperService',['$rootScope', 'networkService', 'xdrService', 'configManager', 'commonModel','itemCartModel','validation','cvsAppData',
    function ($rootScope, NS, XS,CM, CMOD, ICM,VF,CAD) {

        var checkOutInfo = ICM.checkOutInfo();
        var jQuesRes = ICM.getQuestions();
        var placeOrder =  {};
        function convertToTwoDigit (number) {
            return (parseInt(number) < 10) ? '0' + parseInt(number) : number;
        }
        function formatDate(date){
            var formattedDate=date+"";
           if(date && (""+formattedDate.indexOf("/")>-1)){
                var splitDate=date.split('/');
                formattedDate=convertToTwoDigit(splitDate[2])+"-"+convertToTwoDigit(splitDate[0])+"-"+convertToTwoDigit(splitDate[1]);
            }else if(""+formattedDate.indexOf("GMT")>-1){

                var cMonth = convertToTwoDigit(date.getMonth() + 1);
               var cDate = convertToTwoDigit(date.getDate());
                var cYear = date.getFullYear();
                formattedDate=cYear+"-"+cMonth+"-"+cDate;
            }
            else if(formattedDate.indexOf('T') > -1){
                formattedDate = formattedDate.split('T')[0];
           }
           else if(formattedDate.length === 8){
                var dobStr = date;
               formattedDate= dobStr.substring(4)+"-"+dobStr.substring(0,2)+"-"+dobStr.substring(2,4);
           }
            return formattedDate;
        };
        var placeOrderHelperService = {
            storePickUpDetails: setStorePickUpDetails,
            shippingDetails: setShippingDetails,
            nonClinicalQuestion: setNonClinicalQuestion,
            prescriptionDetails: setPrescriptionDetails,
            clinicalQuestion:setClinicalQuestion,
            extraParameter:extraParameter,
            patientContact:patientContact

        };
        return placeOrderHelperService;

        function setStorePickUpDetails(){
            var placeOrderInfo={};
            if (ICM.checkOutInfo('pickOrDel') == 'pickup') {
                placeOrderInfo.storePickupDetails = ICM.checkOutInfo('storeCheckOutInfo');
            }
            return placeOrderInfo;
        }

        function setShippingDetails(){
            var placeOrderInfo={};
            var addressLength=ICM.checkOutInfo('checkOutInfo').address && ICM.checkOutInfo('checkOutInfo').address.length?ICM.checkOutInfo('checkOutInfo').address.length:0;
            var shippingInfo = [];
            if (addressLength > 0) {
                for (var i = 0; i < ICM.checkOutInfo('checkOutInfo').address.length; i++) {
                    ICM.checkOutInfo('checkOutInfo').address[i].phoneNumber = "";
                    delete ICM.checkOutInfo('checkOutInfo').address[i].$$hashKey;
                    shippingInfo.push(ICM.checkOutInfo('checkOutInfo').address[i]);
                }
                placeOrderInfo.shippingDetails = {
                    "shippingInfo": shippingInfo
                };
            }else if(ICM.checkOutInfo('checkOutInfo').address){
                ICM.checkOutInfo('checkOutInfo').address.phoneNumber = "";
                delete ICM.checkOutInfo('checkOutInfo').address.$$hashKey;
                shippingInfo.push(ICM.checkOutInfo('checkOutInfo').address);
                placeOrderInfo.shippingDetails = {
                    "shippingInfo": shippingInfo
                };
            }

            return placeOrderInfo;

        }

        function setNonClinicalQuestion(){
            jQuesRes = ICM.getQuestions();
            var placeOrderInfo={};
            if(_.isEmpty(jQuesRes)){
                return;
            }
            placeOrderInfo.nonClinical ={};
            var nonClinicalQuestions = placeOrderInfo.nonClinical.nonClinicalQuestions={};
                nonClinicalQuestions.allergies ={
                    userResponse:jQuesRes[0].answer,
                    additionalComments:jQuesRes[0].data.answerText || ""

                }

            nonClinicalQuestions.insuranceChanged={
                userResponse:jQuesRes[1].answer,
                insuranceInfo:{
                    cardHolderDOB: jQuesRes[1].data.subscriberName && jQuesRes[1].data.effectiveDate?formatDate(jQuesRes[1].data.dateOfBirth): jQuesRes[1].data.subscriberName?ICM.getPatientInfo()&& ICM.getPatientInfo().getPatientInfo()&& ICM.getPatientInfo().getPatientInfo().dateOfBirth:undefined,
                    cardHolderName: jQuesRes[1].data.subscriberName,
                    effectiveDate: jQuesRes[1].data.subscriberName && jQuesRes[1].data.effectiveDate?formatDate(jQuesRes[1].data.effectiveDate): jQuesRes[1].data.subscriberName?"2016-01-01":undefined,
                    employerName: jQuesRes[1].data.employerName,
                    groupNumber: jQuesRes[1].data.groupNumber,
                    idNumber: jQuesRes[1].data.idNumber,
                    newInsCompName: jQuesRes[1].data.insuranceName,
                    newInsPhoneNo: jQuesRes[1].data.insurancePhone,
                    relationshipToCardHolder: jQuesRes[1].data.relationship,
                    rxBIN: jQuesRes[1].data.bin,
                    rxPCN: jQuesRes[1].data.pcn
                }
            };
            nonClinicalQuestions.insuranceChanged.insuranceInfo.cardHolderDOB = formatDate(nonClinicalQuestions.insuranceChanged.insuranceInfo.cardHolderDOB);
            nonClinicalQuestions.insuranceChanged.insuranceInfo.effectiveDate = formatDate(nonClinicalQuestions.insuranceChanged.insuranceInfo.effectiveDate);
            nonClinicalQuestions.dosageChanged={
            drugInfoForDosageChange:[]
            };
            var dosageInformationChanged=false;
            for(var i=0;i<jQuesRes[2].data.length;i++){

                if(jQuesRes[2].data[i].newdosage != undefined && jQuesRes[2].data[i].frequency != undefined) {
                    var obj={
                        drugName:jQuesRes[2].data[i].drugName,
                        drugNameEnc:jQuesRes[2].data[i].drugNameEnc,
                        rxId:jQuesRes[2].data[i].rxId,
                        newDosage:jQuesRes[2].data[i].newdosage,
                        newFrequency:jQuesRes[2].data[i].frequency
                    };
                    nonClinicalQuestions.dosageChanged.drugInfoForDosageChange.push(obj);
                    dosageInformationChanged=true;
                }

            }
            nonClinicalQuestions.dosageChanged.userResponse= dosageInformationChanged? jQuesRes[2].answer : 'NA';

            var dosageLeftFlag=false;
            nonClinicalQuestions.dosesLeft={};
            for(var i=0;i<jQuesRes[3].data.length;i++){
                var obj={
                    drugName:jQuesRes[3].data[i].drugName,
                    drugNameEnc:jQuesRes[3].data[i].drugNameEnc,
                    rxId:jQuesRes[3].data[i].rxId,
                    nextDosesDate:formatDate(jQuesRes[3].data[i].nextDogeDate),
                    numberOfDosesLeft:jQuesRes[3].data[i].dosageLeft
                };
                if(jQuesRes[3].data[i].drugName != undefined)
                {
                    if(nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft == undefined) {
                        nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft = [];
                    }
                    nonClinicalQuestions.dosesLeft.drugInfoForDosageLeft.push(obj);
                    dosageLeftFlag=true;
                }

            }

            nonClinicalQuestions.dosesLeft.userResponse= dosageLeftFlag ? "yes" : 'NA';

            nonClinicalQuestions.physicianInfoChanges={
                userResponse:jQuesRes[4].answer != undefined ? jQuesRes[4].answer : 'NA',
                physicianInfo:[]
               }
            for(var i=0;i<jQuesRes[4].data.length;i++){
                var obj={
                    drugName:jQuesRes[4].data[i].drugName,
                    drugNameEnc:jQuesRes[4].data[i].drugNameEnc,
                    rxId:jQuesRes[4].data[i].rxId,
                    physicianName:jQuesRes[4].data[i].physicianName,
                    physicianNumber:jQuesRes[4].data[i].physicianPhone
                };
                if(obj.physicianNumber !== undefined && obj.physicianName !== undefined && obj.physicianNumber !== '' && obj.physicianName !== '') {
                    nonClinicalQuestions.physicianInfoChanges.physicianInfo.push(obj);
                }

            }

            nonClinicalQuestions.administerMedicationChanges={
                userResponse:jQuesRes[5].answer!= undefined ? jQuesRes[5].answer : 'NA',
                administerMedication:[]
            }
            for(var i=0;i<jQuesRes[5].data.length;i++){
                if(jQuesRes[5].data[i].answerText !== undefined && jQuesRes[5].data[i].answerText.length > 0) {
                    var obj={
                        drugName:jQuesRes[5].data[i].drugName,
                        drugNameEnc:jQuesRes[5].data[i].drugNameEnc,
                        rxId:jQuesRes[5].data[i].rxId,
                        additionalComments:jQuesRes[5].data[i].answerText
                    };
                    nonClinicalQuestions.administerMedicationChanges.administerMedication.push(obj);
                }

            }
            var patientInfo = ICM.getPatientInfo();
            if(patientInfo.getPatientInfo() && patientInfo.getPatientInfo().medicareIndicator === 'Y' ){
            nonClinicalQuestions.incareFacility={
                userResponse: jQuesRes[6] && jQuesRes[6].answer!= undefined ? jQuesRes[6].answer : 'NA'
            }
            }
            else{
                nonClinicalQuestions.incareFacility={
                    userResponse: 'NA'
                }
            }

            return placeOrderInfo;
        };

        function setPrescriptionDetails(){
            var placeOrderInfo={};
            var refillPres = ICM.getCartItems();
            // placeOrderInfo.prescriptionDetails={};
            // placeOrderInfo.prescriptionDetails.prescriptionInfo=[];
            placeOrderInfo.orderInfos={};
            placeOrderInfo.orderInfo.rxInfos=[];

            for(var i =0 ; i<refillPres.length; i++){
                var obj={};
                var lastUpdatedTime = cvsUtility.parseDateFormat(new Date(), 'yyyy-mm-dd h:m:s', '-', ':', true, ':');


                obj.dispensingStoreDetails=refillPres[i].dispensingStoreDetails;
                obj.estimatedDeliveryDate= cvsUtility.parseDateFormat(new Date(ICM.checkOutInfo('deliveryDate')), 'yyyy-mm-dd');
                obj.hospitalInfo={
                    hospitalAddress1: "",
                    hospitalCity: "",
                    hospitalName: "",
                    hospitalNumber: "",
                    hospitalStateCode: "",
                    hospitalZipCode: ""
                };
                obj.lastUpdatedTimeStamp=lastUpdatedTime;

                if(_.contains($rootScope.qArray , i)){
                    if(jQuesRes[4].data[i].physicianName !== undefined && jQuesRes[4].data[i].physicianPhone != undefined) {
                        obj.physicianChanged= 'yes';
                        obj.physicianInfo={
                            physicianName:jQuesRes[4].data[i].physicianName,
                            physicianNumber:jQuesRes[4].data[i].physicianPhone
                        }
                    }else{
                        obj.physicianChanged= 'no';
                    }
                } else {
                    obj.physicianChanged= 'NA';
                }
                /*else{
                 obj.physicianInfo={
                 physicianName:"",
                 physicianNumber:""
                 }
                 }*/

                obj.prescriptionName= refillPres[i].drugName;
                obj.prescriptionNameEnc= refillPres[i].drugNameEnc;
                /**
                 * SP 11/21/2016 - ITPR015400 - Guest Refill
                 * Using Encrypted Rx number
                 */
                obj.prescriptionNo= refillPres[i].rxNumberEnc ? refillPres[i].rxNumberEnc : refillPres[i].rxNumber;
                obj.prescriptionSystemName= refillPres[i].prescriptionSystemName;
                obj.therapeuticCategory= refillPres[i].therapeuticCategory;
                //placeOrderInfo.prescriptionDetails.prescriptionInfo.push(obj);
                placeOrderInfo.orderInfos.rxInfos.push(obj);
            }
            return placeOrderInfo;
        };

        function setClinicalQuestion(){
            VF.setCallbackInd(false,false);
            var reg = new RegExp('/^\d+$/');
            var placeOrderInfo={};
            var jQuesRes = ICM.getClinicalQuestions();
            // console.log(b);
            //console.log(jQuesRes);
            placeOrderInfo.clinical={};
            var clinicalQuestions = placeOrderInfo.clinical.clinicalQuestions={};
            clinicalQuestions.clinicalQuestion=[];
            if(jQuesRes && jQuesRes.length>0){
            for( var i =0 ; i<jQuesRes.length; i++){
                var freshObj ={};
                freshObj.answerOptions={};
                if(jQuesRes[i].answerType=="SINGLE_SELECT"){
                    freshObj.answerOptions.answerOption=[];
                    freshObj.answerType = jQuesRes[i].answerType;
                    freshObj.questionIdOne = jQuesRes[i].questionId;
                    freshObj.questionIdTwo = jQuesRes[i].questionId2;
                    freshObj.questionText=jQuesRes[i].questionText;
                    freshObj.userResponse= jQuesRes[i].userResponse;
                    if(jQuesRes[i].selectedOption){
                        freshObj.answerId= jQuesRes[i].selectedOption;
                    }
                   /* if(freshObj.questionIdOne=="353" && freshObj.answerId=="484"){
                        VF.setCallbackInd(true,true);
                    }*/
                    if(freshObj.questionText && freshObj.questionText.toLowerCase().replace(/\s+/g, '') === CAD.getConstantMessage().pharmacistQuestion.toLowerCase().replace(/\s+/g, '') && freshObj.userResponse && freshObj.userResponse.toLowerCase()=="yes"){
                        VF.setCallbackInd(true,true);
                    }
                    function recurse(newData,insertArray){
                        for(var j =0 ; j<newData.length;j++){
                            var obj={};
                            //obj.answerId=newData[j].answerId;
                            if(newData[j].answerOptionId && /^\d+$/.test((newData[j].answerOptionId))){
                                obj.answerOptionIDOne=newData[j].answerOptionId;
                            }
                            //obj.answerOptionIDOne=newData[j].answerOptionId;
                            if(newData[j].answerOptionId2 && /^\d+$/.test((newData[j].answerOptionId2))){
                                obj.answerOptionIDTwo=newData[j].answerOptionId2;
                            }
                            obj.answerText=newData[j].answerText || newData[j].answer;
                            obj.subquestions={};
                            if(_.isEmpty(newData[j].subQuestions)){
                                /*obj.subquestions.subQuestion={
                                    answerOptions: "",
                                    answerType: "",
                                    questionId: "",
                                    questionId2: "",
                                    questionText: "",
                                    userResponse: ""
                                }*/
                                insertArray.push(obj);
                            }else{

                                if(newData[j].subQuestions[0].answerType=='MULTI_SELECT'){
                                    obj.subquestions.subQuestion={
                                        answerType: newData[j].subQuestions[0].answerType,
                                        questionIdOne: newData[j].subQuestions[0].questionId,
                                        questionIdTwo: newData[j].subQuestions[0].questionId2,
                                        questionText: newData[j].subQuestions[0].questionText,
                                        answerOptions:{
                                            answerOption:[]
                                        }
                                        /*userResponse: newData[j].subQuestions[0].userResponse || newData[j].subQuestions[0].answerOptions[0].answer,
                                        answerOptions:{
                                            answerOption:[]
                                        }*/
                                    };
                                    var answerOptionsArray=[];
                                    var str =" ";
                                    var answerArray =[];
                                    var lengthOfSubQ=newData[j].subQuestions[0].answerOptions.length;
                                    for(var k = 0; k<lengthOfSubQ;k++){
                                        var obj2= {};
                                        if(newData[j].subQuestions[0].answerOptions[k].answerOptionId && /^\d+$/.test((newData[j].subQuestions[0].answerOptions[k].answerOptionId))){
                                            obj2.answerOptionIDOne=newData[j].subQuestions[0].answerOptions[k].answerOptionId
                                        }
                                        //obj.answerOptionIDOne=newData[j].answerOptionId;
                                        if(newData[j].subQuestions[0].answerOptions[k].answerOptionId2 && /^\d+$/.test((newData[j].subQuestions[0].answerOptions[k].answerOptionId2))){
                                            obj2.answerOptionIDTwo=newData[j].subQuestions[0].answerOptions[k].answerOptionId2
                                        }
                                        obj2.answerText=newData[j].subQuestions[0].answerOptions[k].answerText;
                                        if(newData[j].subQuestions[0].answerOptions[k] && newData[j].subQuestions[0].answerOptions[k].isChecked){
                                            if(!newData[j].subQuestions[0].answerOptions[k].answerText){
                                                str = str +"Y";
                                            }else{
                                                str = str +"/"+newData[j].subQuestions[0].answerOptions[k].answerText;
                                            }
                                            str = str.replace(" /","");
                                            obj.subquestions.subQuestion.userResponse =str;
                                            answerArray.push( obj2.answerOptionIDOne);
                                        }
                                        obj.subquestions.subQuestion.answerOptions.answerOption.push(obj2);
                                    }
                                    if(answerArray && answerArray.length>0){
                                        obj.subquestions.subQuestion.answerId=answerArray;
                                    }
                                    insertArray.push(obj);
                                }else{
                                    obj.subquestions.subQuestion={
                                        answerType: newData[j].subQuestions[0].answerType,
                                        questionIdOne: newData[j].subQuestions[0].questionId,
                                        questionIdTwo: newData[j].subQuestions[0].questionId2,
                                        questionText: newData[j].subQuestions[0].questionText,
                                        userResponse: newData[j].subQuestions[0].userResponse || newData[j].subQuestions[0].answerOptions[0].answer,
                                        answerOptions:{
                                            answerOption:[]
                                        }
                                    };

                                    if(newData[j].subQuestions[0].selectedOption){
                                        obj.subquestions.subQuestion.answerId=newData[j].subQuestions[0].selectedOption;
                                    }
                                    insertArray.push(obj);
                                    recurse(newData[j].subQuestions[0].answerOptions,obj.subquestions.subQuestion.answerOptions.answerOption);
                                }
                                //insertArray.push(obj);
                                /*if(newData[j].subQuestions[0].answerOptions && newData[j].subQuestions[0].answerOptions.length>0){
                                    for(var subObA=0;subObA<newData[j].subQuestions[0].answerOptions.length;subObA++){
                                        if(newData[j].subQuestions[0].answerOptions[subObA].subQuestions){
                                            recurse(newData[j].subQuestions[0].answerOptions,obj.subquestions.subQuestion.answerOptions.answerOption);
                                        }
                                    }
                                }*/

                            }
                        }
                    }
                    recurse(jQuesRes[i].answerOptions,freshObj.answerOptions.answerOption);

                } else if(jQuesRes[i].answerType=="MULTI_SELECT"){
                    var str =" ";
                    var answerArray =[];
                    freshObj.answerOptions.answerOption=[];
                    var answerOption = freshObj.answerOptions.answerOption;
                    for(var j = 0; j<jQuesRes[i].answerOptions.length;j++){
                        var obj= {};
                        obj.subquestions={};
                        if(jQuesRes[i].answerOptions[j].answerOptionId && /^\d+$/.test((jQuesRes[i].answerOptions[j].answerOptionId))){
                            obj.answerOptionIDOne=jQuesRes[i].answerOptions[j].answerOptionId
                        }
                        //obj.answerOptionIDOne=newData[j].answerOptionId;
                        if(jQuesRes[i].answerOptions[j].answerOptionId2 && /^\d+$/.test((jQuesRes[i].answerOptions[j].answerOptionId2))){
                            obj.answerOptionIDTwo=jQuesRes[i].answerOptions[j].answerOptionId2
                        }
                        obj.answerText=jQuesRes[i].answerOptions[j].answerText;
                       if(jQuesRes[i].answerOptions[j] && jQuesRes[i].answerOptions[j].isChecked){

                            str = str +"/"+jQuesRes[i].answerOptions[j].answerText;
                            str = str.replace(" /","");
                            freshObj.userResponse =str;
                            answerArray.push( obj.answerOptionIDOne);
                        }
                        answerOption.push(obj);
                    }
                    freshObj.answerId=answerArray;
                    freshObj.answerType= jQuesRes[i].answerType;
                    freshObj.questionIdOne= jQuesRes[i].questionId;
                    freshObj.questionIdTwo= jQuesRes[i].questionId2;
                    freshObj.questionText= jQuesRes[i].questionText;
                    /*var str =" ";
                    var answerArray =[];
                    freshObj.answerOptions.answerOption=[];
                    var answerOption = freshObj.answerOptions.answerOption;
                    for(var j = 0; j<jQuesRes[i].answerOptions.length;j++){
                        var obj= {};
                        obj.subquestions={};
                        /!*obj.subquestions.subquestion={
                            answerOptions: "",
                            answerType: "",
                            questionId: "",
                            questionId2: "",
                            questionText: "",
                            userResponse: "",
                        }*!/
                        //obj.answerId=jQuesRes[i].answerOptions[j].answerId;
                        if(jQuesRes[i].answerOptionId && reg.test(parseInt(jQuesRes[i].answerOptions[j].answerOptionId))){
                            obj.answerOptionIDOne=jQuesRes[i].answerOptions[j].answerOptionId;
                        }
                        //obj.answerOptionIDOne=newData[j].answerOptionId;
                        if(jQuesRes[i].answerOptionId2 && reg.test(parseInt(jQuesRes[i].answerOptions[j].answerOptionId2))){
                            obj.answerOptionIDTwo=jQuesRes[i].answerOptions[j].answerOptionId2
                        }
                        /!*obj.answerOptionIDOne=jQuesRes[i].answerOptions[j].answerOptionId;
                         obj.answerOptionIDTwo=jQuesRes[i].answerOptions[j].answerOptionId2;*!/
                        obj.answerText=jQuesRes[i].answerOptions[j].answerText;

                        if(jQuesRes[i].answerOptions[j].hasOwnProperty('isChecked')){
                            str = str +"/"+jQuesRes[i].answerOptions[j].answerText
                            str = str.replace(" /","");
                            freshObj.userResponse =str;
                            answerArray.push(obj.answerOptionId);
                        }
                        answerOption.push(obj);
                    }
                    freshObj.answerId=answerArray;
                    freshObj.answerType= jQuesRes[i].answerType;
                    freshObj.questionIdOne= jQuesRes[i].questionId;
                    freshObj.questionIdTwo= jQuesRes[i].questionId2;
                    freshObj.questionText= jQuesRes[i].questionText;*/
                }else if(jQuesRes[i].answerType === 'TEXT_NUMBER') {
                    var answerOption = freshObj.answerOptions.answerOption = {};
                    //answerOption.answerId=jQuesRes[i].answerOptions[0].answerId;
                    answerOption.answerOptionIDOne="";
                    /*answerOption.answerOptionId2="";*/
                    answerOption.answerText="";
                    answerOption.subquestions={};
                    /*answerOption.subquestions.subquestion={
                        answerOptions: "",
                        answerType: "",
                        questionId: "",
                        questionId2: "",
                        questionText: "",
                        userResponse: "",
                    }*/
                    freshObj.answerType= jQuesRes[i].answerType;
                    //console.log("jQuesRes[i].answerOptions[0].answer", jQuesRes[i].answerOptions[0].answer);
                    freshObj.userResponse = jQuesRes[i].answerOptions[0].answer;
                    freshObj.questionIdOne= jQuesRes[i].questionId;
                    freshObj.questionIdTwo= jQuesRes[i].questionId2;
                    freshObj.questionText= jQuesRes[i].questionText;
                    freshObj.answerId=jQuesRes[i].answerOptions[0].answerId;

                }else{
                    var answerOption = freshObj.answerOptions.answerOption={};
                    //answerOption.answerId=jQuesRes[i].answerOptions[0].answerId;
                    answerOption.answerOptionIDOne="";
                    /*answerOption.answerOptionId2="";*/
                    answerOption.answerText="";
                    answerOption.subquestions={};
                    /*answerOption.subquestions.subquestion={
                        answerOptions: "",
                        answerType: "",
                        questionId: "",
                        questionId2: "",
                        questionText: "",
                        userResponse: "",
                    }*/
                    freshObj.answerType= jQuesRes[i].answerType;
                    if(freshObj.answerType==="TEXT_DATE"){
                       freshObj.userResponse =formatDate(jQuesRes[i].answerOptions[0].answer);
                    }
                    freshObj.questionIdOne= jQuesRes[i].questionId;
                    freshObj.questionIdTwo= jQuesRes[i].questionId2;
                    freshObj.questionText= jQuesRes[i].questionText;
                    freshObj.answerId=jQuesRes[i].answerOptions[0].answerId;

                }
                clinicalQuestions.clinicalQuestion.push(freshObj);
            }
            }
            if( clinicalQuestions.clinicalQuestion &&  clinicalQuestions.clinicalQuestion.length <1){
                delete clinicalQuestions.clinicalQuestion;
            };

            return placeOrderInfo;
        };

        function extraParameter(){
            var commonParams={};
            var componentID, linkSource;
            var akamaiHeaders = cvsUtility.getAkamaiHeaders();
            componentID = CAD.isGuestRefill() ? (cvsUtility.queryMap.mobileAppStyle?"RFR":"QR") : (cvsUtility.queryMap.FromQuickRegistration?"QR":"RFR");
            linkSource = CAD.isGuestRefill() ? (cvsUtility.queryMap.mobileAppStyle?"Classic":"QR-RFR") : (cvsUtility.queryMap.FromQuickRegistration?"QR-RFR":"Classic");
            //placeOrderInfo.hostId= '0.0.0.0';
            if (akamaiHeaders && akamaiHeaders.hasOwnProperty('cvs-akclient-ip')) {
                commonParams.hostId = (akamaiHeaders['cvs-akclient-ip'] || header['CVS-AKCLIENT-IP']) ? (akamaiHeaders['cvs-akclient-ip'] || header['CVS-AKCLIENT-IP']) : '0.0.0.0';
            }
            commonParams.componentID= componentID;
            commonParams.fastIndicator="Yes";
            commonParams.linkSource= linkSource;
            //placeOrderInfo.deviceType=navigator.userAgent;

            commonParams.includeAdditionalSupplies=ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").needSupplies ? "Yes" : "No";
            // commonParams.sendCustomerEmail ="false";
            // placeOrderInfo.needsByDate = cvsUtility.parseDateFormat(new Date(ICM.checkOutInfo('deliveryDate')), 'yyyy-mm-dd');
            // commonParams.paymentInfo={
            //     userResponse:"use my previous order payments"
            // };

            /*placeOrderInfo.nurseCareManagement=ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").nurseCall ? "YES" : "NO";
            placeOrderInfo.nurseCareManagement=ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").nurseCallFlag ? placeOrderInfo.nurseCareManagement: "NA";*/
            commonParams.additionalComments={
                userResponse:ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").isOrderComments ? "Yes" : "No",
                userComments:ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").orderComments
            }

            /**
             * SP 12/05/2016 - ITPR015400 Guest refill
             * Passing guest email and terms and conditions flag
             */
            if(ICM.checkOutInfo("patientEmail")){
                commonParams.guestEmail= ICM.checkOutInfo("patientEmail");
            } 

            if(ICM.checkOutInfo("termsAndConditions")){
                commonParams.termsAndConditions=ICM.checkOutInfo("termsAndConditions");
            }

            // placeOrderInfo.signitureForDeliveries=ICM.checkOutInfo("checkOutInfo") && ICM.checkOutInfo("checkOutInfo").signatureRequired ? "Yes" : "No";

            return commonParams;
        }

        function patientContact(){
            String.prototype.replaceAll = function(search, replacement) {
                var target = this;
                return target.split(search).join(replacement);
            };
            if(ICM.checkOutInfo("patientContact")){
               var patientContact={};
                if(ICM.checkOutInfo("patientContact").preferredPhone){
                    patientContact.preferredPhone=ICM.checkOutInfo("patientContact").preferredPhone.replaceAll("-","").substring(0,10);
                }
                if(ICM.checkOutInfo("patientContact").callMeAnyTimeFlag){
                    patientContact.callMeAnyTimeFlag=ICM.checkOutInfo("patientContact").callMeAnyTimeFlag && ICM.checkOutInfo("patientContact").callMeAnyTimeFlag=="YES"?"YES":"NO";
                }
                if(ICM.checkOutInfo("patientContact").choseADayDetails){
                    patientContact.choseADayDetails={
                        mon:ICM.checkOutInfo("patientContact").choseADayDetails && ICM.checkOutInfo("patientContact").choseADayDetails.mon?ICM.checkOutInfo("patientContact").choseADayDetails.mon:"N",
                        tues:ICM.checkOutInfo("patientContact").choseADayDetails && ICM.checkOutInfo("patientContact").choseADayDetails.tues?ICM.checkOutInfo("patientContact").choseADayDetails.tues:"N",
                        wed:ICM.checkOutInfo("patientContact").choseADayDetails && ICM.checkOutInfo("patientContact").choseADayDetails.wed?ICM.checkOutInfo("patientContact").choseADayDetails.wed:"N",
                        thurs:ICM.checkOutInfo("patientContact").choseADayDetails && ICM.checkOutInfo("patientContact").choseADayDetails.thurs?ICM.checkOutInfo("patientContact").choseADayDetails.thurs:"N",
                        fri:ICM.checkOutInfo("patientContact").choseADayDetails && ICM.checkOutInfo("patientContact").choseADayDetails.fri?ICM.checkOutInfo("patientContact").choseADayDetails.fri:"N"
                    };
                    if(ICM.checkOutInfo("patientContact").choseTime){
                        patientContact.choseTime={
                        "morning":ICM.checkOutInfo("patientContact").choseTime && ICM.checkOutInfo("patientContact").choseTime.morning && ICM.checkOutInfo("patientContact").choseTime.morning=="Y"? "Y":"N",
                        "afternoon":ICM.checkOutInfo("patientContact").choseTime && ICM.checkOutInfo("patientContact").choseTime.afternoon && ICM.checkOutInfo("patientContact").choseTime.afternoon=="Y"?"Y":"N",
                        "evening":ICM.checkOutInfo("patientContact").choseTime  && ICM.checkOutInfo("patientContact").choseTime.evening && ICM.checkOutInfo("patientContact").choseTime.evening=="Y"?"Y":"N"}
                    };


                }
                return patientContact;
            }
        }



}]);
